module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-03-m-jp.d11b841d9702931089a6ed82af92aa36.png";